import createReducer from "./../createReducer";
import { handlersUI } from "./handlers";
import { IUIState } from "./types";

export const uiInitialState: IUIState = {
  userOptions: { isOpen: false },
};

export default createReducer(uiInitialState, handlersUI);
